import { StatusTagCondition } from '@sprinklr/display-builder/widgets/utils/getStatusTag';

const resolveDuration = (value: number | Duration): Duration => {
    return typeof value === 'object' ? value : undefined;
};

export function getNewConditionValues(lastCondition: StatusTagCondition) {
    const duration: Duration =
        lastCondition?.type === 'METRIC'
            ? resolveDuration(lastCondition?.value as number)
            : undefined;
    const value: number =
        !duration &&
        // array is most likely a dimension value
        lastCondition?.type === 'METRIC'
            ? (lastCondition?.value as number) + (lastCondition?.comparison === '>' ? -1 : 1)
            : undefined;
    const comparison =
        lastCondition?.type === 'METRIC' && lastCondition?.comparison
            ? lastCondition.comparison
            : '>';

    return {
        value: lastCondition?.value ? duration ?? value : undefined,
        comparison,
    };
}
